var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('c-panel',[_c('form-programa',{attrs:{"paramId":_vm.$route.params.id},on:{"onSubmitPrograma":_vm.onSubmitPrograma}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }